import * as yup from "yup";

export const CertificadoAptitudAmbientalSchema = yup.object().shape({
  numero: yup
    .string()
    .max(20, "errors.certificadoAptitudAmbiental.numero.max")
    .required("errors.certificadoAptitudAmbiental.numero.required")
    .default(""),
  disposicion: yup
    .string()
    .max(20, "errors.certificadoAptitudAmbiental.disposicion.max")
    .required("errors.certificadoAptitudAmbiental.disposicion.required")
    .default(""),
});
